<xemex-page-header
  [title]="deviceStore.deviceDetail()?.deviceLDN ?? ''"
  [subtitle]="$safeNavigationMigration(deviceStore.deviceDetail()?.deviceType)"
  [breadcrumbs]="breadcrumbs"
  [badges]="deviceBadges"
  [badgeSize]="'lg'"
  [loading]="deviceStore.isLoading()"
  [withBackground]="true"
  [withTabBar]="true"
  [imageUrl]="$safeNavigationMigration(deviceStore.deviceDetail()?.deviceImage)"
  [icon]="'router'"
>
  <!-- The tab bar reads the route's tab only when it is created, and the Feeds tab joins once the
       profile has loaded. A new tab bar then lets a link straight to Feeds highlight Feeds. -->
  @if (showInstallations()) {
    <xemex-tab-bar
      [tabs]="availableDeviceTabs"
      [defaultTab]="0"
      (tabChange)="onTabChange($event)"
    ></xemex-tab-bar>
  } @else {
    <xemex-tab-bar
      [tabs]="availableDeviceTabs"
      [defaultTab]="0"
      (tabChange)="onTabChange($event)"
    ></xemex-tab-bar>
  }
</xemex-page-header>

<xemex-page-body [scrollable]="true">
  @if (selectedTab === 'general') {
    <xemex-device-general-tab
      [deviceDetail]="deviceStore.deviceDetail()"
      [partnerRes]="deviceStore.partnerByDeviceId()"
      [locationRes]="deviceStore.locationByDeviceId()"
      [isLoading]="deviceStore.isLoading()"
      [showConnectionTest]="
        permissions().includes('test_device') && deviceDetail?.protocol === 'DLMS'
      "
      [isExecutingConnectionTest]="deviceStore.isExecutingConnectionTest()"
      [showFirmwareUpdate]="canUpdateFirmware"
      [showExportCsv]="canExportData"
      [showInstallationGroups]="canViewInstallationGroups"
      [installationGroups]="deviceStore.installationGroupsByDeviceId()"
      [installationGroupsLoading]="deviceStore.isLoadingInstallationGroups()"
      [isXemex]="isXemexUser"
      [isRefreshingSim]="isRefreshingSim()"
      [isTopUpInProgress]="isTopUpInProgress()"
      [isExtendInProgress]="isExtendInProgress()"
      [showInstallations]="showInstallations()"
      [channelUsage]="channelUsage()"
      (companyClicked)="onCompanyClicked($event)"
      (locationClicked)="onLocationClicked($event)"
      (connectionTestClicked)="onConnectionTestClicked()"
      (firmwareUpdateClicked)="onFirmwareUpdateClicked()"
      (exportCsvClicked)="onExportCsv()"
      (installationGroupClicked)="onInstallationGroupClicked($event)"
      (refreshSimClicked)="onRefreshSimClicked()"
      (topUpSimConfirmed)="onTopUpSimConfirmed()"
      (extendSimConfirmed)="onExtendSimConfirmed()"
    />
  }

  @if (selectedTab === 'insights') {
    <xemex-device-telemetry-tab
      [deviceDetail]="deviceStore.deviceDetail()"
      [partnerDefaultMeterRole]="partnerRes?.partnerDefaultMeterRole"
      [isPerformingReadout]="isPerformingReadout"
      [telemetryNotShared]="topologyTelemetryStore.deviceTelemetryNotShared()"
      (performReadout)="performOnDemandReadout()"
    />
  }

  @if (selectedTab === 'configuration') {
    <xemex-device-configuration-tab
      [permissions]="permissions()"
      [deviceDetail]="deviceStore.deviceDetail()"
      [channelConfiguration]="deviceStore.channelConfiguration()"
      [channelConfigurationError]="deviceStore.channelConfigurationError()"
      [deviceConfigurations]="deviceStore.deviceConfigurations()"
      [verifications]="deviceStore.verificationAttempts()"
      (channelChanged)="onChannelChanged($event)"
      (verificationPageChange)="onVerificationPageChange($event)"
      (viewAllVerifications)="onViewAllVerifications()"
      [isLoadingVerification]="deviceStore.isLoadingVerifications()"
      [isLoadingConfiguration]="deviceStore.isLoadingConfiguration()"
    />
  }

  @if (selectedTab === 'activity') {
    <xemex-device-activity-tab
      [activityRes]="activityRes"
      [isLoading]="activityStore.isLoading()"
      [isXemex]="isXemexUser"
      [initialAction]="activityActionFilter"
      (pageChange)="onActivityPageChange($event)"
      (filterChange)="onActivityFilterChange($event)"
    />
  }

  @if (selectedTab === 'alarms') {
    <xemex-device-alarms-tab
      [deviceDetail]="deviceStore.deviceDetail()"
      [isLoading]="deviceStore.isLoading()"
      (alarmClosed)="onAlarmClosed()"
    />
  }

  @if (selectedTab === 'alarm-settings') {
    <xemex-device-settings-tab
      [deviceDetail]="deviceStore.deviceDetail()"
      [partnerDefaultMeterRole]="partnerRes?.partnerDefaultMeterRole"
      [canManageDeviceSettings]="permissions().includes('manage_device_settings')"
      [canEditPhaseCount]="canEditPhaseCount"
      [canOverridePhaseCountLock]="canOverridePhaseCountLock"
      [canEditMeterRole]="canEditMeterRole"
      [meterConfigManagedByOwner]="deviceStore.phaseCountReadForbidden()"
    />
  }

  @if (selectedTab === 'feeds' && showInstallations()) {
    <xemex-device-feeds-tab [channelUsage]="channelUsage()" [loading]="isLoadingChannelUsage()" />
  }
</xemex-page-body>
